import { Helmet } from "react-helmet";

export default function BlogImportPdfTableToGoogleSheets() {
  return (
    <>
      <Helmet>
        <title>Import PDF Table to Google Sheets – 1-Click Extraction Tool</title>
        <meta
          name="description"
          content="Learn how to import a PDF table into Google Sheets in one click. Extract clean rows and columns instantly with our Google Sheets add-on."
        />
      </Helmet>

      <div style={{ background: "white", color: "black", padding: "30px" }}>
        <h1>How to Import a PDF Table to Google Sheets</h1>
        <p>This page will contain the full guide.</p>
        <h2>Why People Import PDF Tables into Google Sheets</h2>
        <p>
        Most PDF tables cannot be copied properly. The formatting breaks, columns merge,
        and manual typing takes too much time. This guide shows the easiest way to import
        a full table from a PDF into Google Sheets in just one click.
        </p>

        <h2>How to Import a PDF Table into Google Sheets (1-Click Method)</h2>
        <ol>
        <li>Open a Google Sheet.</li>
        <li>Go to <b>Extensions → Add-ons → Get add-ons</b>.</li>
        <li>Search for <b>PDF to Google Sheets: Table & Invoice OCR</b>.</li>
        <li>Click <b>Install</b>.</li>
        <li>Open the sidebar from <b>Extensions → PDF to Google Sheets</b>.</li>
        <li>Upload your PDF file.</li>
        <li>Select the page if it's a multi-page PDF.</li>
        <li>Click <b>Extract</b> to import the table directly into the sheet.</li>
        </ol>

        <h2>What You Get After Importing</h2>
        <ul>
        <li>Clean rows and columns</li>
        <li>Original table layout preserved</li>
        <li>No manual typing</li>
        <li>Works for invoices, reports, bank statements, etc.</li>
        </ul>

        <h2>Install the Add-on</h2>
        <p>
        Use the button below to install the Google Sheets add-on and start importing PDF tables instantly.
        </p>

        <a
        href="https://workspace.google.com/marketplace/app/pdf_to_google_sheets_table_invoice_ocr/687083288287"
        target="_blank"
        style={{
            display: "inline-block",
            background: "#0b57d0",
            color: "white",
            padding: "12px 20px",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
        }}
        >
        Install Add-on
        </a>

        <h2>FAQ</h2>
        <h3>Does this work for scanned PDFs?</h3>
        <p>Yes, scanned PDFs are supported as long as the table is visible clearly.</p>

        <h3>Is the formatting preserved?</h3>
        <p>Yes. Rows, columns, and table structure remain intact after import.</p>

        <h3>Does this work for multi-page PDFs?</h3>
        <p>Yes. You can select which PDF page you want to import from.</p>

      </div>
    </>
  );
}
